export default "__VITE_ASSET__CLdSasn$__"